let DealerHtmlOverlayClass = null;

const getDealerHtmlOverlayClass = () => {
  if (DealerHtmlOverlayClass) return DealerHtmlOverlayClass;
  if (typeof window === "undefined" || !window.T?.Overlay?.extend) {
    return null;
  }

  DealerHtmlOverlayClass = window.T.Overlay.extend({
    initialize(lnglat, element, options = {}) {
      this.lnglat = lnglat;
      this._element = element;
      this._anchor = options.anchor || "bottom";
    },
    onAdd(map) {
      this.map = map;
      const el = this._element;
      if (!el) return;

      el.style.position = "absolute";
      el.style.pointerEvents = "auto";
      el.style.willChange = "left, top";
      if (this._anchor === "bottom") {
        el.style.transform = "translate(-50%, -100%)";
      } else {
        el.style.transform = "translate(-50%, -50%)";
      }

      const panes = map.getPanes?.();
      const pane = panes?.overlayPane || panes?.markerPane || map.getContainer?.();
      if (!pane) return;
      pane.appendChild(el);

      this._handleMapChange = () => this.update();
      ["move", "zoom", "drag", "moveend", "zoomend", "dragend"].forEach(
        (eventName) => {
          map.addEventListener?.(eventName, this._handleMapChange);
        }
      );
      this.update();
    },
    onRemove() {
      const el = this._element;
      if (el?.parentNode) {
        el.parentNode.removeChild(el);
      }
      if (this.map && this._handleMapChange) {
        ["move", "zoom", "drag", "moveend", "zoomend", "dragend"].forEach(
          (eventName) => {
            this.map.removeEventListener?.(eventName, this._handleMapChange);
          }
        );
      }
      this.map = null;
      this._handleMapChange = null;
    },
    setLngLat(lnglat) {
      this.lnglat = lnglat;
      this.update();
    },
    draw() {
      this.update();
    },
    update() {
      if (!this.map || !this._element || !this.lnglat) return;
      const pos = this.map.lngLatToLayerPoint?.(this.lnglat);
      if (!pos) return;
      const x = typeof pos.getX === "function" ? pos.getX() : pos.x;
      const y = typeof pos.getY === "function" ? pos.getY() : pos.y;
      if (!Number.isFinite(x) || !Number.isFinite(y)) return;
      this._element.style.left = `${x}px`;
      this._element.style.top = `${y}px`;
    },
  });

  return DealerHtmlOverlayClass;
};

/** 天地图 HTML 标记：支持 DOM 元素（含脉冲动画）贴图定位 */
export const attachTiandituHtmlMarker = (map, lngLat, element, options = {}) => {
  const OverlayClass = getDealerHtmlOverlayClass();
  if (!map || !OverlayClass || !element) {
    return { remove() {}, setLngLat() {}, bringToFront() {}, resetZIndex() {} };
  }

  const overlay = new OverlayClass(lngLat, element, options);
  map.addOverLay(overlay);

  return {
    remove() {
      try {
        map.removeOverLay(overlay);
      } catch (e) {
        overlay.onRemove?.();
      }
    },
    setLngLat(ll) {
      overlay.setLngLat(ll);
    },
    bringToFront() {
      element.style.zIndex = "600";
    },
    resetZIndex() {
      element.style.zIndex = "";
    },
    _overlay: overlay,
  };
};
